import React from 'react';

function YoutubePlayButton() {
  return (
    <>
      {/* Natural YouTube play button */}
      <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-all duration-300">
        {/* Simple main button */}
        <div className="relative w-[24px] h-[24px] lg:w-[30px] lg:h-[30px] bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transform group-hover:scale-110 active:scale-95 transition-all duration-200 shadow-lg">
          {/* Centered play triangle */}
          <svg
            className="w-[18px] h-[18px] lg:w-[24px] lg:h-[24px] text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>
    </>
  );
}

export default YoutubePlayButton;
